import { Component, OnInit } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
    InterfaceValidationSelectionService,
    InterfaceValidationSelectionState,
} from '../interface-validation-selection.service';

@Component({
    selector: 'app-multi-shipment-screen',
    template: `<rt-trip-error-multi [ormIds]="ids$ | async"></rt-trip-error-multi>`,
})
export class InterfaceValidationMultiScreenComponent implements OnInit {
    ids$: Observable<number[]>;
    selectionState$: Observable<InterfaceValidationSelectionState>;

    constructor(private selectionService: InterfaceValidationSelectionService) {}

    ngOnInit(): void {
        this.selectionState$ = this.selectionService.selectionState$;
        this.ids$ = this.selectionState$.pipe(
            map((state) => state.selectedIds.map((ormId) => Number(ormId))),
        );
    }
}
